import ReactDOM from "react-dom/client";
import { Routes } from "@generouted/react-router";
import { RaygunProvider } from "@/providers/RaygunProvider";
import Providers from "@/providers/providers";

import "./styles";
import { DevBanner } from "./components/Banner";
import { showDevBanner } from "./lib/urlUtils";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <RaygunProvider>
    <Providers>
      {showDevBanner && (
        <DevBanner
          description="Currently in Development"
          compactDescription="Development"
          variant="info"
          primaryAction={{
            label: "Switch to Production",
            compactLabel: "Switch",
            link: `https://m360.pgahq.com${window.location.pathname}`
          }}
        />
      )}
      <Routes />
    </Providers>
  </RaygunProvider>
);
